import quickActionIcon from '../../../assets/image/quick_action/quick-action-icon.svg'
import quickActionInventoryIcon from '../../../assets/image/quick_action/inventory-icon.svg'
import quickActionSaleIcon from '../../../assets/image/quick_action/sales-icon.svg'
import quickActionPurchaseIcon from '../../../assets/image/quick_action/purchase-icon.svg'
import quickActionUserIcon from '../../../assets/image/user.svg'
import '../../../layout/Layout.scss';
import { hasPermission } from '../../../utils/controller'

export default function QuickAction({ user, navigation, suburl }) {
  const actions = [
    {
      icon: quickActionInventoryIcon, style: { width: 30, height: 30 },
      title: "Inventory",
      items: [
        {
          title: 'Add Products',
          permission: 'inventory.products.create',
          action: 'product-create',
        },
        {
          title: 'Add Groups',
          permission: 'inventory.groups.create',
          action: 'group'
        },
        {
          title: 'Add Adjustments',
          permission: 'inventory.adjustments.create',
          action: 'inventory-adjustment-crete'
        },
      ]
    },
    {
      icon: quickActionSaleIcon, style: { width: 30, height: 30 },
      title: "Sales",
      items: [
        {
          title: 'Add Customers',
          permission: 'sales.customers.create',
          action: 'customers-create'
        },
        {
          title: 'Add Doctors',
          permission: 'sales.doctors.create',
          action: 'doctors-create'
        },
        {
          title: 'Add Invoices',
          permission: 'sales.invoices.create',
          action: 'invoices-create',
        },
        {
          title: 'Add Payment Received',
          permission: 'sales.payments_received.create',
          action: 'payments-received-create'
        },
        {
          title: 'Add Sales Return',
          permission: 'sales.sales_return.create',
          action: 'sales-return-create'
        },
        {
          title: 'Add Credit Notes',
          permission: 'sales.credit_notes.create',
          action: 'sales/credit-note-create'
        },
      ]
    },
    {
      icon: quickActionPurchaseIcon, style: { width: 30, height: 30 },
      title: "Purchase",
      items: [
        {
          title: 'Add Vendor',
          permission: 'purchases.vendors.create',
          action: 'vendor-create'
        },
        {
          title: 'Add Purchase Order',
          permission: 'purchases.purchase_orders.create',
          action: 'purchases-order-create',
        },
        {
          title: 'Add Purchase Receive',
          permission: 'purchases.purchase_receives.create',
          action: 'purchases-receive-create'
        },
        {
          title: 'Add Purchase Bills',
          permission: 'purchases.purchase_bills.create',
          action: 'purchases-bills-create'
        },
        {
          title: 'Add Payment Made',
          permission: 'purchases.payments_made.create',
          action: 'payment-made-create'
        },
        {
          title: 'Add Credit Note',
          permission: 'purchases.credit_notes.create',
          action: 'credit-note-create'
        },
      ]
    },
    {
      icon: quickActionUserIcon, style: { width: 30, height: 30 },
      title: 'User & Role',
      items: [
        {
          title: 'Add User',
          permission: 'settings.users.create',
          action: 'users',
        },
        {
          title: 'Add Role',
          permission: 'settings.roles.view',
          action: 'roles',
        }
      ]
    }
  ];
  const hasAccess = (item) => hasPermission(
    item.permission,
    user?.role?.role_permissions
  );

  return (
    <div className='rounded-top-4'>
      <div className="d-flex justify-content-between align-items-center quick-title-bg-color p-3 rounded-top-4">
        <div className="d-flex gap-2 align-items-center rounded-top-4">
          <img src={quickActionIcon} alt="" width={40} height={40} />
          <div>
            <div className='fs-4 font-medium'>Quick Actions</div>
            <div className='fs-5 font-small text-gray'>Create anything instantly</div>
          </div>
        </div>
      </div>
      <div className="d-flex py-3 px-2">
        {actions.map((section, index) => (
          <div className={`quick-action-border-color align-items-start ${index !== actions.length - 1 ? 'border-end' : ''}`}>
            <div className='d-flex gap-3 align-items-center quick-action-border-color border-bottom mx-4 py-2'>
              <div className="icon-box">
                <img src={section.icon} alt="" width={section.style.width} height={section.style.height} />
              </div>
              <h5>{section.title}</h5>
            </div>
            <ul className="quick-action-menu">
              {section.items.map((item, index) => (
                <div className="content-wrapper">
                  <li key={index} className={!hasAccess(item) ? 'quick-cursor-disabled' : ''}
                    onClick={() => {
                      if (!hasAccess(item)) return;
                      navigation(
                        section?.title !== 'User & Role'
                          ? `/user/${suburl}/${item.action}`
                          : `/user/${suburl}/settings/${item.action}`
                      );
                    }}
                  >
                    {item.title}
                  </li>
                </div>
              ))}
            </ul>

          </div>
        ))}
      </div>
      <div className="quick-title-bg-color font-14 px-3 py-2 rounded-bottom-4" style={{ color: '#555B67' }}>
        Click any action to get started instantly
      </div>
    </div>);
}
